/**
 * The request is fulfilled once the nurse being added covers the last open slot,
 * counting nurses that were already approved on the request.
 */
export const willFulfillRequest = (approvedNursesCount: number, neededNurses: number): boolean => approvedNursesCount + 1 >= neededNurses;
